<div class="panel-shell upgrade-panel-shell">
  <header class="panel-header accent">
    <div class="panel-title text-bold flex-row-start-center">
      <mat-icon class="mr-8">{{ upgradeIcon }}</mat-icon>
      <span>{{ "UPGRADE_PANEL." + featureKey + ".TITLE" | translate }}</span>
      <span class="pro-badge ml-8">{{
        "UPGRADE_PANEL.PRO_BADGE" | translate
      }}</span>
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <p *ngIf="content.tagline" class="tagline">
      {{ "UPGRADE_PANEL." + featureKey + ".TAGLINE" | translate }}
    </p>

    <p class="intro">
      {{ "UPGRADE_PANEL." + featureKey + ".INTRO" | translate }}
    </p>

    <ul class="benefit-list" *ngIf="content.benefits.length > 0">
      <li *ngFor="let benefit of content.benefits" class="benefit">
        <mat-icon class="benefit-icon">check_circle</mat-icon>
        <div class="benefit-body">
          <div class="benefit-title">
            {{
              "UPGRADE_PANEL." + featureKey + ".BENEFITS." + benefit + ".TITLE"
                | translate
            }}
          </div>
          <div class="benefit-text">
            {{
              "UPGRADE_PANEL." + featureKey + ".BENEFITS." + benefit + ".TEXT"
                | translate
            }}
          </div>
        </div>
      </li>
    </ul>

    <ng-container *ngIf="content.steps.length > 0">
      <div class="steps-title">
        {{ "UPGRADE_PANEL.HOW_IT_WORKS" | translate }}
      </div>
      <ol class="step-list">
        <li *ngFor="let step of content.steps; let i = index" class="step">
          <span class="step-number">{{ i + 1 }}</span>
          <span class="step-text">
            {{ "UPGRADE_PANEL." + featureKey + ".STEPS." + step | translate }}
          </span>
        </li>
      </ol>
    </ng-container>

    <ul class="feature-list" *ngIf="items.length > 0">
      <li *ngFor="let item of items" class="flex-row-start-center">
        <mat-icon class="item-icon" [class.soon]="item.soon">
          {{ item.soon ? "schedule" : "check_circle" }}
        </mat-icon>
        <span>
          {{ "UPGRADE_PANEL." + featureKey + ".ITEMS." + item.key | translate }}
          <em *ngIf="item.soon" class="soon-label">
            ({{ "UPGRADE_PANEL.COMING_SOON" | translate }})
          </em>
        </span>
      </li>
    </ul>

    <p *ngIf="content.punch" class="punch">
      {{ "UPGRADE_PANEL." + featureKey + ".PUNCH" | translate }}
    </p>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="order()"
    >
      {{ "UPGRADE_PANEL.ORDER" | translate }}
    </button>
    <button
      *ngIf="kbSlug"
      mat-stroked-button
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="learnMore()"
    >
      {{ "UPGRADE_PANEL.LEARN_MORE" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mr-8 ml-8 mt-4 mb-4"
      (click)="close()"
    >
      {{ "UPGRADE_PANEL.CLOSE" | translate }}
    </button>
  </footer>
</div>
